import { Route, Routes } from "react-router-dom";

import Payment from "./Payment";
import PaymentInfoPage from "./PaymentInfoPage";
import PaymentCompletion from "./PaymentCompletion";

export default function PaymentPage() {
  return (
    <>
      <Routes>
        <Route index element={<PaymentInfoPage />} />
        <Route path="/:id" element={<Payment />} />
        <Route path="/completion" element={<PaymentCompletion />} />
      </Routes>
    </>
  );
}
